<template>
  <ul class="private-wapper message-ul">
    <li v-for="(item, index) in comment.data" :key="index">
      <router-link
        v-if="item.sendUserId"
        :to="{ name: 'Personal', query: { uid: item.sendUserId, type: 'mine' } }"
      >
        <img
          class="private-avatar"
          :src="formatAvatar(item.sendUserId, item)"
          alt=""
        />
      </router-link>
      <a v-else>
        <img
          class="private-avatar"
          :src="formatAvatar(item.sendUserId, item)"
          alt=""
        />
      </a>
      <div class="user-name">
        {{ item.user.userName || "管理员" }}
      </div>

      <div class="private-message">
        {{ item.noticeContent }}
      </div>
      <div class="private-date">
        {{ dateFormat(item.createTime) }}
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import dateFormat from "@/utils/dateFormat";
export default defineComponent({
  name: "Comment",
  props: {
    comment: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup() {
    function formatAvatar(id: string, item: any) {
      let src = "";
      if (!Number(id)) {
        src =
          "https://beinabncc.oss-cn-beijing.aliyuncs.com/News/1e0ba2777e56d0e72327afb20bcb792a.jpg";
      } else {
        src = item.user.userImg;
      }
      return src;
    }
    return {
      dateFormat,
      formatAvatar,
    };
  },
});
</script>

<style lang="scss" scoped>
/*
    私信内容
  */

.private-wapper {
  width: 355px;
  margin: 0 auto;
}
.private-wapper li {
  padding: 10px 10px;
  box-sizing: border-box;
  position: relative;
  padding-left: 55px;

  border-bottom: 6px solid #fff;
}
.private-avatar {
  width: 35px;
  height: 35px;
  position: absolute;
  left: 10px;
  top: 20px;
  border-radius: 50%;
}

.user-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #444444;
  font-size: 15px;
  margin: 5px 0;
  margin-top: 7.5px;
}

.private-date {
  color: #999999;
  font-size: 14px;
  margin-top: 10px;
}
/*
    点赞
  */

.support-wapper {
  width: 355px;
  margin: 0 auto;
  li {
    padding: 20px 10px;
    box-sizing: border-box;
    border-bottom: 6px solid #fff;

    .support-date {
      color: #999999;
      font-size: 14px;
    }
    .support-content {
      color: #999999;
      font-size: 15px;
      margin-top: 15px;
      position: relative;
    }
    .supporter-avatar {
      width: 27px;
      height: 27px;
      border-radius: 50%;
      vertical-align: middle;
    }
    .supporter-name {
      margin-left: 10px;
      width: 75px;
      display: inline-block;
      vertical-align: middle;
      line-height: 27px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #444444;
      font-size: 14px;
    }
  }
}
.private-message {
 /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;*/
  color: #999999;
  font-size: 14px;
  position: relative;
  margin-top: 10px;
  .support-icon {
    width: 14.5px;
    height: 14.5px;

    position: absolute;
    right: 0;
  }
}
</style>
